import { TagMap } from "../../types";
import queryString from "query-string";
import { removeAccessTokenFromUrl } from "../../utils";
import { useEffect } from "react";
import { useHistory } from "react-router-native";
import { useLocation } from "react-router-native";
import { useSelector } from "react-redux";

// type: Query
const useQueryParams = () => {
  const { pathname, search } = useLocation();
  const tagsState: TagMap = useSelector((state: any) => state.tags);
  const settingsState = useSelector((state: any) => state.settings);
  const history = useHistory();

  const {
    capacity,
    safe,
    sort,
    order,
    tags,
    search: searchTerm,
    date,
    dashboard,
    impersonate,
  } = queryString.parse(search);

  useEffect(() => {
    const params = new URLSearchParams();
    if (settingsState !== null && settingsState !== undefined) {
      Object.keys(settingsState).map((key) => {
        if (
          key === "date" ||
          key === "dashboard" ||
          key === "search" ||
          key === "sort" ||
          key === "safe" ||
          key === "capacity" ||
          key === "order" ||
          key === "impersonate"
        ) {
          if (settingsState[key]) {
            const param: string = settingsState[key]
              ? settingsState[key]!.toString()
              : "";
            params.set(key, param);
          }
        }
      });
    }
    if (tagsState !== null && tagsState !== undefined) {
      let tagsString = "";

      Object.keys(tagsState).map((id: string) => {
        if (tagsState[id].selected) {
          tagsString = tagsString + (tagsString === "" ? "" : ",") + id;
        }
      });
      if (tagsString !== "") {
        params.set("tags", tagsString);
      }
    }
    if (params.toString()) {
      history.push({ search: `?${params.toString()}` });
      removeAccessTokenFromUrl();
    }
  }, [tagsState, settingsState]);

  return {
    safe,
    capacity,
    sort,
    order,
    tags,
    search: searchTerm,
    date,
    dashboard,
    impersonate,
  };
};

export default useQueryParams;
